(() => {
  'use strict';
  if (window.ITPRecognitionV22) { window.ITPRecognitionV22.refresh(); return; }
  const roots = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const motionAllowed = () => document.documentElement.dataset.motion !== 'off' && document.documentElement.dataset.readingCalm !== 'on' && (!reduced.matches || document.documentElement.dataset.motionChoice === 'on');
  function initialize(root) {
    if (roots.has(root)) return;
    const track = root.querySelector('[data-rail22-track]');
    const controls = root.querySelector('[data-rail22-controls]');
    const buttons = [...root.querySelectorAll('[data-rail22-step]')];
    if (!track || !controls || !buttons.length) return;
    const abort = new AbortController();
    let frame = 0;
    const update = () => {
      frame = 0;
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      controls.hidden = maximum < 3;
      for (const button of buttons) button.disabled = Number(button.dataset.rail22Step) < 0 ? track.scrollLeft < 3 : track.scrollLeft >= maximum - 3;
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    for (const button of buttons) button.addEventListener('click', () => {
      track.scrollBy({ left: Number(button.dataset.rail22Step) * Math.max(240, track.clientWidth * .86), behavior: motionAllowed() ? 'smooth' : 'auto' });
    }, { signal: abort.signal });
    track.addEventListener('scroll', schedule, { passive: true, signal: abort.signal });
    addEventListener('resize', schedule, { passive: true, signal: abort.signal });
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    observer?.observe(track);
    for (const image of track.querySelectorAll('img')) image.addEventListener('load', schedule, { once: true, signal: abort.signal });
    roots.set(root, () => { abort.abort(); observer?.disconnect(); if (frame) cancelAnimationFrame(frame); });
    update();
  }
  function scan(scope = document) {
    if (scope.matches?.('[data-rail22]')) initialize(scope);
    scope.querySelectorAll?.('[data-rail22]').forEach(initialize);
    for (const [root, destroy] of roots) if (!root.isConnected) { destroy(); roots.delete(root); }
  }
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, destroy] of roots) if (event.target === root || event.target.contains(root)) { destroy(); roots.delete(root); }
  });
  window.ITPRecognitionV22 = { refresh: () => scan() };
  scan();
})();
